/**
 * The CopilotKit message-scroll container has no stable class, so we locate it
 * at runtime: the first ancestor of `.copilotKitMessages` that actually
 * scrolls (scrollHeight > clientHeight). Shared by the restore (scroll to
 * newest) and the infinite-scroll loader (detect scroll-to-top).
 */
export function findChatScroller(): HTMLElement | null {
  const list = document.querySelector<HTMLElement>(".copilotKitMessages");
  let el = list?.parentElement ?? null;
  for (let i = 0; i < 8 && el; i++) {
    if (el.scrollHeight - el.clientHeight > 1) return el;
    el = el.parentElement;
  }
  return null;
}

/**
 * Jump the chat to the newest message. CopilotKit leaves a bulk `setMessages`
 * scrolled at the top, so after restoring history we pin to the bottom (where
 * the user left off) across a few frames to outlast message layout.
 */
export function scrollChatToBottom(): void {
  [0, 60, 180, 360].forEach((delay) =>
    setTimeout(() => {
      const sc = findChatScroller();
      if (sc) sc.scrollTop = sc.scrollHeight;
    }, delay),
  );
}
